import { Fragment } from 'react'

import Navigation from './navigation'
import HeadLine from './head-line'
import AboutMe from './about-me'
import ContractMe from './contract-me'
import Publication from './publication'
import Footer from './footer'

export default function Home(){
  return (
    <Fragment>
      <Navigation />
      <main>
        <HeadLine />
        <AboutMe />
        <ContractMe />
        <Publication />
      </main>
      <Footer />
    </Fragment>
  )
}
